import React, {useEffect } from "react";
import MobileProfileTopNavigation from "./MobileProfileTopNavigation";
import AboutUsSection from "../../PageComponent/ProfilePage/AboutUsSection";

function MobileAboutUs() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div className="text-coalBlack px-6 pt-10">
      <MobileProfileTopNavigation pageTitle={"About Us"} />
      <AboutUsSection />
    </div>
  );
}

export default MobileAboutUs;
